export enum PASSENGER_LOYALTY_TYPE {
  EXPL = 'FF',
  SILV = 'FO',
  PLAT = 'PM',
  GOLD = 'GM',
  CLUB = 'DM',
  OA = 'OA'
}

export enum CHECK_IN_STATUS {
  NOT_CHECKED_IN = 'NOT_CHECKED_IN',
  CHECKED_IN = 'CHECKED_IN',
  STANDBY = 'STANDBY'
}

export enum RESERVATION_TYPE {
  REVENUE = 'REVENUE',
  AWARD = 'AWARD',
  GROUP = 'GROUP',
  STAFF_BUSINESS = 'STAFF_BUSINESS',
  STAFF_LEISURE = 'STAFF_LEISURE',
  DELTA_VACATIONS = 'DELTA_VACATIONS'
}
export enum PASSENGER_TICKET_TYPE {
  ETICKET = 'ETICKET',
  PAPER = 'PAPER',
  TICKETLESS = 'TICKETLESS'
}
export enum PASSENGER_TYPE_CATEGORY {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  YOUNG_ADULT = 'YOUNG_ADULT',
  INFANT_WITH_SEAT = 'INFANT_WITH_SEAT',
  INFANT_IN_ARMS = 'INFANT_IN_ARMS'
}
export enum CABIN_CODE {
  F = 'F',
  W = 'W',
  C = 'C',
  Y = 'Y'
}
export enum PRODUCT_CODE {
  BE = 'BE',
  MAIN = 'MAIN',
  FIRST = 'FIRST',
  DPPS = 'DPPS',
  D1 = 'D1',
  SB = 'SB',
  DCP = 'DCP',
  VSUP = 'VSUP',
  VSPE = 'VSPE',
  VSDT = 'VSDT',
  VSLT = 'VSLT',
  VSCL = 'VSCL'
}

export enum SEAT_ASSIGN_STATUS {
  ASSIGNED = 'ASSIGNED',
  EXTRA = 'EXTRA',
  RESERVED = 'RESERVED'
}

export enum SEAT_SELECTION_TYPE {
  assignedAtGate = 'ASSIGNED_AT_GATE',
  assignedAtCheckin = 'ASSIGNED_AT_CHECKIN',
  selectSeat = 'SELECT_SEAT',
  viewSeat = 'VIEW_SEAT',
  unassigned = 'SEAT_UNASSIGNED'
}

export enum BOOKING_REF_ORG {
  DL = 'DL',
  DLV = 'DLV',
  OA = 'OA'
}

export enum OFFER_TYPE {
  CASH = 'CASH',
  MILES = 'MILES',
  MIXED = 'MIXED'
}
